import { SOCIAL_AD_TYPES } from "utils/constants";
import { invalidCharacters, MEGA } from "utils/common";

import {
	maxLength,
	requiredNotNull
} from "widgets/forms/validators/validators";
import { creativeNameAllowedChars, creativeNameMaxLength } from "widgets/forms/validators/Creatives";
import { filesize, dimensions } from "widgets/forms/validators/Assets";
import {
	requiredAsset,
	errorMessageReducer
} from "./validators";

export const YOUTUBE_DISCOVERY_CONSTRAINTS = {
	MAX_LENGTH_VIDEO_TITLE: 100,
	MAX_LENGTH_HEADLINE: 100,
	MAX_LENGTH_DESCRIPTION_1: 35,
	MAX_LENGTH_DESCRIPTION_2: 35,

	VIDEO_ACCEPT: ".mp4, .mov",
	MAX_VIDEO_MB: 512,

	THUMBNAIL_ACCEPT: ".jpg, .jpeg, .gif, .png",
	MAX_THUMBNAIL_MB: 2,
	THUMBNAIL_DIMENSIONS: {
		minWidth: 640,
		minHeight: 360,
	},
};

export function youTubeDiscoveryWarning(allValues, props) {
	const {
		MAX_LENGTH_VIDEO_TITLE,
		MAX_LENGTH_HEADLINE,
		MAX_LENGTH_DESCRIPTION_1,
		MAX_LENGTH_DESCRIPTION_2,
		MAX_VIDEO_MB,
		MAX_THUMBNAIL_MB,
		THUMBNAIL_DIMENSIONS,
	} = YOUTUBE_DISCOVERY_CONSTRAINTS;

	const formName = SOCIAL_AD_TYPES.YOUTUBE_DISCOVERY;
	const values = allValues[formName] || {};

	const warn = {
		video: [requiredAsset, filesize({ max: MAX_VIDEO_MB * MEGA })],
		thumbnail: [requiredAsset, filesize({ max: MAX_THUMBNAIL_MB * MEGA }), dimensions(THUMBNAIL_DIMENSIONS)],
		videoTitle: [requiredNotNull, maxLength(MAX_LENGTH_VIDEO_TITLE)],
		headline: [requiredNotNull, maxLength(MAX_LENGTH_HEADLINE)],
		description1: [requiredNotNull, maxLength(MAX_LENGTH_DESCRIPTION_1)],
		description2: [requiredNotNull, maxLength(MAX_LENGTH_DESCRIPTION_2)],
	};

	return errorMessageReducer(warn, values, formName);
}

export function youTubeDiscoveryValidator(allValues, props) {
	const formName = SOCIAL_AD_TYPES.YOUTUBE_DISCOVERY;
	const values = allValues[formName] || {};

	const validators = {
		name: [requiredNotNull, creativeNameMaxLength, creativeNameAllowedChars],
	};

	return errorMessageReducer(validators, values, formName);
}

const YOUTUBE_INSTREAM_DESCRIPTION_PATTERN = /^[^<>]+$/;

export function youtubeInstreamDescriptionAllowedChars(value) {
	const invalidCharactersFunc = invalidCharacters(YOUTUBE_INSTREAM_DESCRIPTION_PATTERN, value);
	const NAME_ERROR_MESSAGE = `${invalidCharactersFunc.join(" ")} ${invalidCharactersFunc.length > 1 ? 'are' : 'is'} not permitted in creative names`;
	return invalidCharactersFunc.length ? NAME_ERROR_MESSAGE : undefined;
}

export const YOUTUBE_INSTREAM_CONSTRAINTS = {
	MAX_LENGTH_VIDEO_TITLE: 100,
	MAX_LENGTH_DESCRIPTION: 5000,
	MAX_LENGTH_HEADLINE: 15,
	MAX_LENGTH_LANDING_PAGE: 800,
	MAX_LENGTH_CTA: 10,

	VIDEO_ACCEPT: ".mp4, .mov",
	MAX_VIDEO_MB: 512,

	MAX_THUMBNAIL_MB: 2,
	THUMBNAIL_ACCEPT: ".jpg, .jpeg, .gif, .png",
	THUMBNAIL_DIMENSIONS: {
		minWidth: 640,
		minHeight: 360,
	},
};

export function youTubeInStreamWarning(allValues, props) {
	const {
		MAX_LENGTH_VIDEO_TITLE,
		MAX_VIDEO_MB,
		MAX_LENGTH_DESCRIPTION,
	} = YOUTUBE_INSTREAM_CONSTRAINTS;

	const formName = SOCIAL_AD_TYPES.YOUTUBE_INSTREAM;
	const values = allValues[formName] || {};

	const warn = {
		video: [requiredAsset, filesize({ max: MAX_VIDEO_MB * MEGA })],
		videoTitle: [requiredNotNull, maxLength(MAX_LENGTH_VIDEO_TITLE)],
		description: [requiredNotNull, youtubeInstreamDescriptionAllowedChars, maxLength(MAX_LENGTH_DESCRIPTION)],
		videoPrivacyStatus: [requiredNotNull],
		madeForKids: [requiredNotNull],
	};

	return errorMessageReducer(warn, values, formName);
}

export function youTubeInStreamValidator(allValues, props) {
	const formName = SOCIAL_AD_TYPES.YOUTUBE_INSTREAM;
	const values = allValues[formName] || {};

	const validators = {
		name: [requiredNotNull, creativeNameMaxLength, creativeNameAllowedChars],
	};

	return errorMessageReducer(validators, values, formName);
}
